// firebase config
const firebaseConnect = {
    apiKey: "AIzaSyA-sQyY1pLPJo-VhauhryzKzv8bVCeHRtg",
    authDomain: "couchpotato-4d31d.firebaseapp.com",
    databaseURL: "https://couchpotato-4d31d.firebaseio.com",
    projectId: "couchpotato-4d31d",
    storageBucket: "gs://couchpotato-4d31d.appspot.com",
    messagingSenderId: "458757461477"
  };
  
  export { firebaseConnect }
  